import styled from '@emotion/styled'

export const AuthUIWrapper = styled.div`
  display: flex;
  padding-top:100px;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  .loginOptionLogo{
    height: 22px;
    text-align: center;
    flex-shrink: 0;
    margin-right: 25px;
  }
  .pageHeader{
    font-size:32px;
    color: #000000;
    margin-bottom:50px;
    margin-top:50px;
  }
  .loginOptionListContainer{
    padding-bottom:60px;
  }
  .loginOption{
    background: #EDEDED;
    border-radius: 9px;
    min-width:300px;
    height: 64px;
    color: #000000;
    font-size:24px;
    margin-bottom:15px;
    margin-top:15px;
    text-transform:none !important;
    :hover{
        background: #21C769;
        font-size:20px;
    }
  }
  `;